import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class ConveyanceCommunitySoaFulfillmentResultDto {
    soaFulfillmentId: number;

    @Type(() => Date)
    fulfilledDate: Date;

    @Type(() => UserNameDisplayResultDto)
    fulfilledBy: UserNameDisplayResultDto;

    communityCheckAmount: number;
    managementCheckAmount: number;

    // Transient variable
    communityId?: number;
    communityName: string;

    get fulfilledByDisplayText(): string {
        return Utils.notNullAndDefined(this.fulfilledBy) ? this.fulfilledBy.displayName : '';
    }
}
